/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL2F0dGVuZGluZy9jb21wb25lbnQvbW9uaXRvcmluZy9zdGVwL21vbml0b3Jpbmctc3RlcC5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL2F0dGVuZGluZy9jb21wb25lbnQvbW9uaXRvcmluZy9zdGVwL21vbml0b3Jpbmctc3RlcC5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/attending/component/monitoring/step/monitoring-step.component.css.shim.ngstyle.ts